export const NEW_SESSION_SCROLL_AREA_CLASS =
  "flex-1 min-h-0 flex flex-col items-center overflow-y-auto py-4 md:py-8";

export const NEW_SESSION_WELCOME_COLUMN_CLASS =
  "mt-14 gap-6 md:mt-[18vh] md:gap-10 w-[560px] items-center";

export const NEW_SESSION_MASCOT_SIZE_CLASS = "size-20 md:size-[100px]";
